module.exports = __webpack_public_path__ + "img/3.30bca745.svg";